import LoaderIcon from '../../static/images/pawLoader.svg'
import DogWithBall from '../../static/images/dog_with_ball.svg'

const PawLoader = ({ isBigVersion, isFetchingFailed }) => {

  const bigVersionMessage = !isFetchingFailed ? 'We’re fetching this page' :
  'We could not fetch the page. You may have tracking prevention set to strict. Please adjust your browser settings and try again.'

  return (
    <div
      className={`flex w-full px-6 py-5 items-center ${
        isBigVersion ? 'flex-col h-full justify-center' : 'justify-center'
      }`}
      style={isBigVersion ? { transform: 'scale(0.5)' } : null}
    >
      <div className={isBigVersion ? '' : 'inline-block  h-14 w-14 mr-4'}>
        {isBigVersion ? <DogWithBall /> : <LoaderIcon />}
      </div>
      <div style={{ textAlign: 'center', fontSize: isBigVersion ? '64px' : '16px' }}>
        {isBigVersion ? (
          !isFetchingFailed ? (
            `We’re fetching this page`
          ) : (
            <>
              <div style={{ fontSize: '64px' }}>We could not fetch the page</div>
              <div style={{ fontSize: '28px'}}>
                You may have tracking prevention set to strict on your MS Edge web browser. Please click the lock icon in the address bar above and toggle “Tracking prevention for this site (Strict)” to off.
              </div>
            </>
          )
        ) : (
          `We're fetching the information...`
        )}
      </div>
    </div>
  )
}

export default PawLoader
